import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const pageLoad = createJpdExperience(
	new UFOExperience('jpd.collections', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

export const create = createJpdExperience(
	new UFOExperience('jpd.collections.create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadCollections = createJpdExperience(
	new UFOExperience('jpd.collections.load-collections', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadViewCount = createJpdExperience(
	new UFOExperience('jpd.collections.load-view-count', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadUsers = createJpdExperience(
	new UFOExperience('jpd.collections.load-users', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadProjects = createJpdExperience(
	new UFOExperience('jpd.collections.load-projects', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createCollection = createJpdExperience(
	new UFOExperience('jpd.collections.create-collection', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const copyCollection = createJpdExperience(
	new UFOExperience('jpd.collections.copy-collection', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const deleteCollection = createJpdExperience(
	new UFOExperience('jpd.collections.delete-collection', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateCollection = createJpdExperience(
	new UFOExperience('jpd.collections.update-collection', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadCollection = createJpdExperience(
	new UFOExperience('jpd.collections.load-collection', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadCollectionViews = createJpdExperience(
	new UFOExperience('jpd.collections.load-collection-views', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadCollectionDescription = createJpdExperience(
	new UFOExperience('jpd.collections.load-collection-description', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const updateCollectionDescription = createJpdExperience(
	new UFOExperience('jpd.collections.update-collection-description', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createView = createJpdExperience(
	new UFOExperience('jpd.collections.create-view', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const deleteView = createJpdExperience(
	new UFOExperience('jpd.collections.delete-view', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
